import { transformGetPathSweeps, transformPathLineInputPath } from 'src/service/navigation/data';
import {
  CombinedSweep,
  ITargetObjectData,
  NavigationType,
  RequestFunction
} from 'src/service/navigation/types';

export class PathFinder {
  constructor(private tourId: any, private requestFn: RequestFunction) {}

  async createPath(
    pathStartSID: string,
    pathEndSID: string,
    pathCalculationSweeps: Map<string, CombinedSweep>,
    targetObjectData?: ITargetObjectData,
    navigationType: NavigationType = NavigationType.Shortest
  ): Promise<{ path: any; hasTeleports: any }> {
    if (!pathStartSID || !pathEndSID) {
      console.error('Error creating path');
      return { path: [], hasTeleports: false };
    }

    const res = await this.requestFn(
      transformGetPathSweeps(pathCalculationSweeps),
      pathStartSID,
      pathEndSID,
      this.tourId,
      navigationType
    );

    const path = transformPathLineInputPath(res.path, pathCalculationSweeps);
    if (targetObjectData) {
      path.push({
        data: {
          position: {
            x: targetObjectData.positionX,
            y: targetObjectData.positionY,
            z: targetObjectData.positionZ
          }
        }
      });
    }
    return { path, hasTeleports: res.hasTeleports };
  }
}
